module.exports = __webpack_public_path__ + "img/list-task.178b19ec.svg";